'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouterBootstrap = require('react-router-bootstrap');

var _reactRedux = require('react-redux');

var _reduxModulesAuth = require('../redux/modules/auth');

var _utilsUtils = require('../utils/utils');

var _components = {
	_$TopNavBar: {
		displayName: 'TopNavBar'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var TopNavBar = (function (_React$Component) {
	_inherits(TopNavBar, _React$Component);

	function TopNavBar() {
		_classCallCheck(this, _TopNavBar);

		_React$Component.apply(this, arguments);
	}

	TopNavBar.prototype.handleLogout = function handleLogout(e) {
		e.preventDefault();
		this.props.logout();
	};

	TopNavBar.prototype.redirect = function redirect(e, url, params) {
		e.preventDefault();
		this.context.history.pushState(null, url, params);
	};

	TopNavBar.prototype.render = function render() {
		var _this = this;

		var items = [{
			id: 'chart',
			title: 'Graf',
			url: '/chart',
			icon: 'fa fa-bar-chart',
			onClick: function onClick(e) {
				_this.redirect(e, '/chart');
			}
		}, {
			id: 'trigger',
			title: 'Triggery',
			url: '/',
			icon: 'fa fa-bolt',
			onClick: function onClick(e) {
				_this.redirect(e, '/trigger');
			}
		}, {
			id: 'data',
			title: 'Data',
			url: '/database',
			icon: 'fa fa-database',
			onClick: function onClick(e) {
				_this.redirect(e, '/database');
			}
		}, {
			id: 'user',
			title: 'Uživatelé',
			url: '/user',
			icon: 'icon-users',
			onClick: function onClick(e) {
				_this.redirect(e, '/user');
			}
		}, {
			id: 'setting',
			title: 'Nastavení',
			icon: 'fa fa-cog',
			items: [{
				id: 'emailtemplate',
				title: 'E-mailové šablony',
				url: '/emailtemplate',
				onClick: function onClick(e) {
					_this.redirect(e, '/emailtemplate');
				}
			}]
		}];
		var activeRoute = this.props.routes[this.props.routes.length - 1].menu || this.props.routes[this.props.routes.length - 1].name;

		var buttons = items.map(function (button) {

			if (button.items) {
				var subitems = button.items.map(function (button) {
					return _react2['default'].createElement(
						'li',
						{ key: button.id, className: _classnames2['default']({ active: activeRoute == button.id }) },
						_react2['default'].createElement(
							'a',
							{ href: button.url, onClick: button.onClick },
							_react2['default'].createElement('span', { style: { fontSize: 12 }, className: button.icon + " position-left" }),
							' ',
							button.title
						)
					);
				});
				return _react2['default'].createElement(
					'li',
					{ key: button.id, className: _classnames2['default']({ dropdown: true, active: activeRoute == button.id }) },
					_react2['default'].createElement(
						'a',
						{ href: '#', onClick: button.onClick, className: 'dropdown-toggle', 'data-toggle': 'dropdown' },
						_react2['default'].createElement('span', { className: button.icon + " position-left" }),
						' ',
						button.title,
						' ',
						_react2['default'].createElement('span', { className: 'caret' })
					),
					_react2['default'].createElement(
						'ul',
						{ className: 'dropdown-menu', role: 'menu' },
						subitems
					)
				);
			}
			return _react2['default'].createElement(
				'li',
				{ key: button.id, className: _classnames2['default']({ active: activeRoute == button.id }) },
				_react2['default'].createElement(
					'a',
					{ href: button.url, onClick: button.onClick },
					_react2['default'].createElement('span', { className: button.icon + " position-left" }),
					' ',
					button.title
				)
			);
		});

		var isPhone = _utilsUtils.getWindowSize().width < 768;

		return _react2['default'].createElement(
			'div',
			null,
			_react2['default'].createElement(
				'div',
				{ className: 'navbar ' + (isPhone ? 'navbar-inverse' : 'navbar-default') },
				_react2['default'].createElement(
					'div',
					{ className: 'navbar-header' },
					_react2['default'].createElement(
						'a',
						{ className: 'navbar-brand visible-xs-block', href: '/', style: { fontWeight: 'bold', color: '#FFF' } },
						'Alertoid'
					),
					_react2['default'].createElement(
						'ul',
						{ className: 'nav navbar-nav no-border visible-xs-block' },
						_react2['default'].createElement(
							'li',
							null,
							_react2['default'].createElement(
								'a',
								{ className: 'text-right  collapsed', 'data-toggle': 'collapse', 'data-target': '#navbar-second-toggle' },
								_react2['default'].createElement('i', { className: 'icon-menu7' })
							)
						)
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: 'navbar-collapse collapse', id: 'navbar-second-toggle' },
					_react2['default'].createElement(
						'ul',
						{ className: 'nav navbar-nav' },
						buttons
					),
					_react2['default'].createElement(
						'ul',
						{ className: 'nav navbar-nav navbar-right' },
						_react2['default'].createElement(
							'li',
							{ className: 'dropdown' },
							_react2['default'].createElement(
								'a',
								{ href: '#', className: 'dropdown-toggle', 'data-toggle': 'dropdown' },
								_react2['default'].createElement('span', { className: 'glyphicon glyphicon-user' }),
								' ',
								this.props.user && this.props.user.name,
								_react2['default'].createElement('span', { className: 'caret' })
							),
							_react2['default'].createElement(
								'ul',
								{ className: 'dropdown-menu', role: 'menu' },
								_react2['default'].createElement(
									'li',
									null,
									_react2['default'].createElement(
										'a',
										{ href: '#', onClick: function (e) {
												return _this.redirect(e, '/profile');
											} },
										_react2['default'].createElement('i', { className: 'icon-user-plus' }),
										' Můj profil'
									)
								),
								_react2['default'].createElement('li', { className: 'divider' }),
								_react2['default'].createElement(
									'li',
									null,
									_react2['default'].createElement(
										'a',
										{ onClick: function (e) {
												return _this.handleLogout(e);
											}, href: '#' },
										_react2['default'].createElement('i', { className: 'icon-switch2' }),
										' Odhlásit'
									)
								)
							)
						)
					)
				)
			)
		);
	};

	_createClass(TopNavBar, null, [{
		key: 'contextTypes',
		value: {
			history: _react2['default'].PropTypes.object
		},
		enumerable: true
	}]);

	var _TopNavBar = TopNavBar;
	TopNavBar = _wrapComponent('_$TopNavBar')(TopNavBar) || TopNavBar;
	TopNavBar = _reactRedux.connect(function (state) {
		return { user: state.auth.identity };
	}, { logout: _reduxModulesAuth.logout })(TopNavBar) || TopNavBar;
	return TopNavBar;
})(_react2['default'].Component);

exports['default'] = TopNavBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/TopMenu.js
 ** module id = 961
 ** module chunks = 2
 **/